export enum TrainingStatus {
	Pending = 0,
	Trained = 10,
	Expiring = 20,
	Expired = 30,
}